import { Actions } from 'vuex-smart-module';
import { ResponseStatuses } from '@/enums';
import { Filters, FiltersPagination } from '@/types';
import { Repairs } from '@/modules/repairs/types';
import { RepairsService } from '../../../services';
import ReturnZipsGetters from './getters';
import ReturnZipsMutations from './mutations';
import ReturnZipsState from './state';

const repairsService = new RepairsService();

export default class ReturnZipsActions extends Actions<
  ReturnZipsState,
  ReturnZipsGetters,
  ReturnZipsMutations,
  ReturnZipsActions
> {
  async get_return_zips() {
    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;
      const payload: FiltersPagination<Filters> = {
        filters: this.state.filters,
        pagination: {
          limit: itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.TOGGLE_LOADING_RETURN_ZIPS(true);
      const { data, meta } = await repairsService.get_repairs_zip(payload);

      this.mutations.SET_RETURN_ZIPS_LIST(data.items);
      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.log(error);
    } finally {
      this.mutations.TOGGLE_LOADING_RETURN_ZIPS(false);
    }
  }

  async get_transport_companies() {
    try {
      const { data } = await repairsService.get_transport_companies();

      this.mutations.SET_TRANSPORT_COMPANIES(data.items);
    } catch (error) {
      console.log(error);
    }
  }

  async send_return_zips(payload: Repairs.UpdReturnZips) {
    try {
      const { code = ResponseStatuses.Success.UPDATED } = await repairsService.send_return_zips(payload);

      return code;
    } catch (error) {
      console.log(error);
    }
  }
}
